import React, { createContext, useContext, useEffect, useState } from "react";
import { api, saveAuth, getUser, clearAuth } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getUser());
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    saveAuth(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    // No auto-login: the agent must sign in only after admin activates.
    return data;
  };

  const refreshMe = async () => {
    const { data } = await api.get("/auth/me");
    localStorage.setItem("traveloble_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const logout = () => {
    clearAuth();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, refreshMe, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
